import $api from "../http";

/**
 * `C.4` (`oq-ММБ-206`): адресаты тревог о связи — ручки админки.
 *
 * Все четыре ручки и пробное письмо — только `root`: сервер отвечает `403`
 * остальным, а раздел в меню у них не показывается.
 */

export type AlarmRecipient = {
  id: number;
  email: string;
  enabled: boolean;
  created_by: number | null;
  created_at: string | null;
  updated_at: string | null;
};

export default class AlarmRecipientsApi {
  static async list(): Promise<AlarmRecipient[]> {
    const response = await $api.get("/admin/alarm-recipients", {
      withCredentials: true,
    });

    return response.data;
  }

  static async add(email: string): Promise<AlarmRecipient> {
    const response = await $api.post(
      "/admin/alarm-recipients",
      { email },
      { withCredentials: true },
    );

    return response.data;
  }

  static async setEnabled(
    id: number,
    enabled: boolean,
  ): Promise<AlarmRecipient> {
    const response = await $api.patch(
      `/admin/alarm-recipients/${id}`,
      { enabled },
      { withCredentials: true },
    );

    return response.data;
  }

  static async remove(id: number): Promise<AlarmRecipient> {
    const response = await $api.delete(`/admin/alarm-recipients/${id}`, {
      withCredentials: true,
    });

    return response.data;
  }

  static async sendTest(id: number): Promise<{ id: number; sent: boolean }> {
    const response = await $api.post(
      `/admin/alarm-recipients/${id}/test`,
      {},
      { withCredentials: true },
    );

    return response.data;
  }
}
